<section id="pageCover" class="row">
    <img src="../../../assets/images/contactCover.png" alt="" class="pageCover">
    <!--<div class="row pageTitle">Projects</div>-->
    <div class="row pageBreadcrumbs">
        <!--<ol class="breadcrumb">
            <li><a href="index.html">home</a></li>
            <li class="active">Projects</li>
        </ol>-->
    </div>
</section>

<section id="blogs" class="row">
    <div class="container">
        <div class="row">
            <div class="col-sm-9">
                <div class="row">
                    <div class="row blog sinlge-blog">
                        <div class="row m0 blogInner">
                            <div class="row m0 blogDateTime">
                                <i class="fa fa-calendar"></i> 14 November 2014, 10:50 AM
                            </div>
                            <div class="row m0 featureImg">
                                <a routerLink="/article">
                                    <img src="../../../../assets/images/projects/project1.png" alt="Faceted Search Has Landed" class="img-responsive">
                                </a>
                            </div>
                            <div class="row m0 postExcerpts">
                                <div class="row m0 postExcerptInner">
                                    <a routerLink="/article" class="postTitle row m0"><h4>Faceted Search Has Landed</h4></a>
                                    <p>This is Photoshop's version  of Lorem Ipsum. Proin gravida nibh vel velit auctor aliquet. Aenean sollicitudin, lorem quis bibendum auctor, nisi elit consequat ipsum, nec sagittis sem nibh id elit. Duis sed odio sit amet nibh vulputate cursus a sit amet mauris. Morbi accumsan ipsum velit. Nam nec tellus a odio tincidunt auctor a ornare odio. <br> <br>

Sed non  mauris vitae erat consequat auctor eu in elit. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos. Mauris in erat justo. Nullam ac urna eu felis dapibus condimentum sit amet a augue. Sed non neque elit. Sed ut imperdiet nisi. Proin condimentum fermentum nunc. Etiam pharetra, erat sed fermentum feugiat, velit mauris egestas quam, ut aliquam massa nisl quis neque. Suspendisse in orci enim. </p>
                                </div>
                            </div>
                        </div>
                    </div>  
                    <div class="row comments">
                        <h3 class="commentsCount">8 Comments</h3>
                        <div class="commentDisplay row m0">
                            <div class="media row m0 comment">
                                <div class="media-left avatar">
                                    <a href="#">
                                        <img src="../../../../assets/images/blog/avatar.png" alt="" class="media-object img-responsive">
                                    </a>
                                </div>
                                <div class="media-body">
                                    <div class="row m0 commenterNtime"><a href="#">ShaneFreer</a>58 minutes ago </div>
                                    <div class="commentTexts row m0">great post!</div>
                                </div>
                            </div>
                            <div class="row m0 commentreply1 commentreply comment media">
                                <div class="media-left replyindicator">
                                    <a href="#">
                                        <img src="../../../../assets/images/blog/replyIndicator.png" alt="" class="media-object img-responsive">
                                    </a>
                                </div>
                                <div class="media-left avatar">
                                    <a href="#">
                                        <img src="../../../../assets/images/blog/avatar.png" alt="" class="media-object img-responsive">
                                    </a>
                                </div>
                                <div class="media-body">
                                    <div class="row m0 commenterNtime"><a href="#">Collis Ta'eed</a>42 minutes ago </div>
                                    <div class="commentTexts row m0">yeah i really like it too, very useful!</div>
                                </div>
                            </div> <!--Reply-->
                            <div class="row m0 commentreply2 commentreply comment media">
                                <div class="media-left replyindicator">
                                    <a href="#">
                                        <img src="../../../../assets/images/blog/replyIndicator.png" alt="" class="media-object img-responsive">
                                    </a>
                                </div>
                                <div class="media-left avatar">
                                    <a href="#">
                                        <img src="../../../../assets/images/blog/avatar.png" alt="" class="media-object img-responsive">
                                    </a>
                                </div>
                                <div class="media-body">
                                    <div class="row m0 commenterNtime"><a href="#">jremick</a>22 minutes ago </div>
                                    <div class="commentTexts row m0">i found this post very useful too, the comment form works just perfect, keep it up guys :) </div>
                                </div>
                            </div> <!--Reply-->
                            <div class="row m0 commentreply3 commentreply comment media">
                                <div class="media-left replyindicator">
                                    <a href="#">
                                        <img src="../../../../assets/images/blog/replyIndicator.png" alt="" class="media-object img-responsive">
                                    </a>
                                </div>
                                <div class="media-left avatar">
                                    <a href="#">
                                        <img src="../../../../assets/images/blog/avatar.png" alt="" class="media-object img-responsive">
                                    </a>
                                </div>
                                <div class="media-body">
                                    <div class="row m0 commenterNtime"><a href="#">joshjanssen</a>22 minutes ago </div>
                                    <div class="commentTexts row m0">yep, especially when it comes to comment testing</div>
                                </div>
                            </div> <!--Reply-->
                            <div class="row m0 commentreply2 commentreply comment media">
                                <div class="media-left replyindicator">
                                    <a href="#">
                                        <img src="../../../../assets/images/blog/replyIndicator.png" alt="" class="media-object img-responsive">
                                    </a>
                                </div>
                                <div class="media-left avatar">
                                    <a href="#">
                                        <img src="../../../../assets/images/blog/avatar.png" alt="" class="media-object img-responsive">
                                    </a>
                                </div>
                                <div class="media-body">
                                    <div class="row m0 commenterNtime"><a href="#">stewboon</a>22 minutes ago </div>
                                    <div class="commentTexts row m0">nice job!</div>
                                </div>
                            </div> <!--Reply-->
                            <div class="row m0 commentreply1 commentreply comment media">
                                <div class="media-left replyindicator">
                                    <a href="#">
                                        <img src="../../../../assets/images/blog/replyIndicator.png" alt="" class="media-object img-responsive">
                                    </a>
                                </div>
                                <div class="media-left avatar">
                                    <a href="#">
                                        <img src="../../../../assets/images/blog/avatar.png" alt="" class="media-object img-responsive">
                                    </a>
                                </div>
                                <div class="media-body">
                                    <div class="row m0 commenterNtime"><a href="#">bensmithett</a>42 minutes ago </div>
                                    <div class="commentTexts row m0">couldn't be better :D</div>
                                </div>
                            </div> <!--Reply-->
                            <div class="media row m0 comment">
                                <div class="media-left">
                                    <a href="#">
                                        <img src="../../../../assets/images/blog/avatar.png" alt="" class="media-object img-responsive">
                                    </a>
                                </div>
                                <div class="media-body">
                                    <div class="row m0 commenterNtime"><a href="#">justinfrench</a>48 minutes ago </div>
                                    <div class="commentTexts row m0">looks very promising</div>
                                </div>
                            </div>
                        </div>
                    </div>    
                    <div class="row commentForm">
                        <h3>Leave a Comment</h3>
                        <form action="#" class="row m0">
                            <div class="col-sm-6 p0 commenterInfoInputs">
                                <div class="row m0">
                                    <div class="input-group">
                                        <span class="input-group-addon"><i class="fa fa-user"></i></span>
                                        <input type="text" class="form-control" placeholder="Name">
                                    </div>
                                    <div class="input-group">
                                        <span class="input-group-addon"><i class="fa fa-envelope"></i></span>
                                        <input type="email" class="form-control" placeholder="e-mail">
                                    </div>
                                    <div class="input-group">
                                        <span class="input-group-addon"><i class="fa fa-link"></i></span>
                                        <input type="url" class="form-control" placeholder="website">
                                    </div>
                                </div>
                            </div>
                            <div class="col-sm-6 p0">
                                <div class="row m0">                                        
                                    <div class="input-group">
                                        <textarea  placeholder="Message" class="form-control"></textarea>
                                    </div>
                                    <button class="btn btn-default" type="submit">post a comment</button>
                                </div>
                            </div>
                        </form>
                    </div>                  
                </div>
            </div>
            <aside class="col-sm-3 sidebar">
                <div class="row m0 recentPostWidget widgetS">
                    <h4>Recent Posts</h4>
                    <div class="row m0 recentblogs">
                        <div class="media recentblog">
                            <div class="media-left">
                                <a href="#">
                                    <img class="media-object" src="../../../../assets/images/blog/recent1.png" alt="">
                                </a>
                            </div>
                            <div class="media-body">
                                <a href="#"><h5 class="media-heading">This is PhotoShop's version of Lorem Ipsum</h5></a>
                            </div>
                        </div>
                        <div class="media recentblog">
                            <div class="media-left">
                                <a href="#">
                                    <img class="media-object" src="../../../../assets/images/blog/recent2.png" alt="">
                                </a>
                            </div>
                            <div class="media-body">
                                <a href="#"><h5 class="media-heading">This is PhotoShop's version of Lorem Ipsum</h5></a>
                            </div>
                        </div>
                        <div class="media recentblog">
                            <div class="media-left">
                                <a href="#">
                                    <img class="media-object" src="../../../../assets/images/blog/recent3.png" alt="">
                                </a>
                            </div>
                            <div class="media-body">
                                <a href="#"><h5 class="media-heading">This is PhotoShop's version of Lorem Ipsum</h5></a>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row m0 contactWidget widgetS">
                    <h4>Contact us</h4>
                    <ul class="list-unstyled">
                        <li><i class="fa fa-phone"></i> 9930 1234 5678</li>
                        <li><i class="fa fa-envelope"></i> contact@yourdomain.com</li>
                        <li><i class="fa fa-home"></i> street address example</li>
                    </ul>
                </div>
                <div class="row m0 textWidget widgetS">
                    <h4>Text Widget</h4>
                    <p>
                        This is Photoshop's version  of Lorem Ipsum. Proin gravida . Aenean sollicitudin, lorem quis bibendum <br><br>auctor, nisi elit consequat ipsum, nec sagittis sem nibh id
                    </p>
                </div>
            </aside>
        </div>            
    </div>
</section>